export const updateUrlSearchParams = (navigate, updates, { replace = true } = {}) => {
  const url = new URL(window.location.href);

  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, String(value));
    }
  });

  navigate(`${url.pathname}${url.search}`, { replace });
};

export const parsePageParam = (params, defaultPage = 1) => {
  const page = Number(params?.page);
  return Number.isFinite(page) && page > 0 ? page : defaultPage;
};

export const parseSearchParam = (params) => params?.search || null;

export const parseFloorParam = (params, defaultFloor = 0) => {
  if (params?.floor === undefined || params?.floor === null || params?.floor === "") {
    return defaultFloor;
  }
  const floor = Number(params.floor);
  return Number.isFinite(floor) && floor >= 0 ? floor : defaultFloor;
};

export const getReturnToParam = () =>
  `${window.location.pathname}${window.location.search}`;

export const buildPatientIpUrl = (pathWithQuery) => {
  const url = new URL(pathWithQuery, window.location.origin);
  if (!url.searchParams.get("returnTo")) {
    url.searchParams.set("returnTo", getReturnToParam());
  }
  return `${url.pathname}${url.search}`;
};

export const resolveReturnTo = (returnTo) => {
  if (!returnTo || typeof returnTo !== "string") return null;
  try {
    const decoded = decodeURIComponent(returnTo);
    // Only allow same-origin relative paths
    if (!decoded.startsWith("/") || decoded.startsWith("//")) return null;
    return decoded;
  } catch {
    return null;
  }
};
